// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { getIsLocalCacheHydrated } from '../../offline/cache/localCacheSelector';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Utils
import { isMobileMode } from '../../platform/utils/platformDetailsUtils';

// Components
import PageLoaderMain from './PageLoaderMain';
import MobileHeader from '../../mobile/structural/MobileHeader';

// Styles
import './PageLoader.scss';

const PageLoader = () => {
    const isLocalCacheHydrated = useSelector(getIsLocalCacheHydrated);
    const platformDetails = useSelector(getPlatformDetailsSelector);

    return (
        <div className="PageLoader">
            <div className="WorkspaceWrapper">
                {isMobileMode(platformDetails) ? (
                    <MobileHeader className="MobileBoardHeader" />
                ) : (
                    <header className="AppHeader">
                        <div className="WorkspaceToolsHeader header-tools" />
                    </header>
                )}
                <div className="Workspace">
                    <div className="WorkspacePositioner">
                        <div id="toolbar" className="Toolbar" />
                        {!isLocalCacheHydrated && <PageLoaderMain />}
                    </div>
                </div>
                <div className="MobileToolbar" />
            </div>
        </div>
    );
};

export default PageLoader;
